import { init } from '@fullstory/browser';
import { getEnv } from 'shared/utils/getEnv';

const initializeFullstory = () => {
  init({ orgId: getEnv('VITE_APP_FULLSTORY_ORG_ID') });
};

export default initializeFullstory;
